module.exports = __webpack_public_path__ + "static/media/expand-content.7832d92a.svg";